import api from '../api';

const folderService = {
    // === Folder Operations ===

    // Get all root folders (owned + shared)
    getRootFolders: () => api.get('/v1/folders'),

    // Get or create user's home folder
    getHomeFolder: () => api.get('/v1/folders/home'),

    // Get folder contents (subfolders + files)
    getFolderContents: (folderId) => api.get(`/v1/folders/${folderId}`),

    // Create a new folder
    createFolder: (payload) => api.post('/v1/folders', payload),

    // Update (rename/move) a folder
    updateFolder: (folderId, payload) => api.put(`/v1/folders/${folderId}`, payload),

    // Delete a folder
    deleteFolder: (folderId) => api.delete(`/v1/folders/${folderId}`),

    // Search folders and files
    search: (query) => api.get('/v1/folders/search', { params: { q: query } }),

    // Move a folder
    moveFolder: (folderId, newParentId) => api.post(`/v1/folders/${folderId}/move`, { parent_id: newParentId }),

    // Move a file
    moveFile: (fileId, newFolderId) => api.post(`/v1/files/${fileId}/move`, { folder_id: newFolderId }),

    // === Folder Sharing ===

    // Get folder share details
    getFolderShareDetails: (folderId) => api.get(`/v1/folders/${folderId}/share`),

    // Share folder with users
    shareFolder: (folderId, payload) => api.post(`/v1/folders/${folderId}/share`, payload),

    // Remove folder share
    removeFolderShare: (folderId, userId) => api.delete(`/v1/folders/${folderId}/share/${userId}`),

    // Get available users for folder sharing
    getAvailableUsersForFolderSharing: (folderId) => api.get(`/v1/folders/${folderId}/share/available-users`),

    // === File Operations ===

    // Upload file to folder
    uploadFile: (folderId, file, onProgress) => {
        const formData = new FormData();
        formData.append('file', file);

        return api.post(`/v1/folders/${folderId}/upload`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: onProgress
                ? (progressEvent) => {
                    const percentCompleted = Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total
                    );
                    onProgress(percentCompleted);
                }
                : undefined,
        });
    },

    // Get file info
    getFile: (fileId) => api.get(`/v1/files/${fileId}`),

    // Delete file
    deleteFile: (fileId) => api.delete(`/v1/files/${fileId}`),

    // Get file view URL
    getFileViewUrl: (fileId) => api.get(`/v1/files/${fileId}/view`),

    // === File Sharing ===

    // Get file share details
    getFileShareDetails: (fileId) => api.get(`/v1/files/${fileId}/share`),

    // Share file with users
    shareFile: (fileId, payload) => api.post(`/v1/files/${fileId}/share`, payload),

    // Remove file share
    removeFileShare: (fileId, userId) => api.delete(`/v1/files/${fileId}/share/${userId}`),

    // Get available users for file sharing
    getAvailableUsersForFileSharing: (fileId) => api.get(`/v1/files/${fileId}/share/available-users`),

    // === Dashboard Widget ===

    // Get all recent files (owned + shared) ordered by created_at desc, paginated
    getRecentFiles: (page = 1, perPage = 15) =>
        api.get('/v1/files', { params: { page, per_page: perPage } }),

    // === OnlyOffice ===

    // Get OnlyOffice editor config for a file (documentUrl, key, fileType, title)
    getOnlyOfficeConfig: (fileId) => api.get(`/v1/files/${fileId}/onlyoffice-config`),
};

export default folderService;
